import React, { useState } from 'react';

// ============================================
// SearchBar Component
// A simple search input with a button.
// User types a city name and clicks search.
// ============================================

function SearchBar({ onSearch, loading, onDetectLocation, locationLoading }) {
  // State to store the input value
  const [city, setCity] = useState('');

  /**
   * Handles form submission
   * Prevents page reload and calls the parent's search function
   */
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent page refresh
    onSearch(city);     // Call parent function with city name
  };

  /**
   * Handles Enter key press for quick search
   */
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSearch(city);
    }
  };

  return (
    <div className="search-wrapper">
      <form className="search-bar" onSubmit={handleSubmit}>
        {/* City Input Field */}
        <input
          type="text"
          className="search-input"
          placeholder="Enter city name... (e.g., Mumbai, London)"
          value={city}
          onChange={(e) => setCity(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={loading}
        />

        {/* Search Button */}
        <button
          type="submit"
          className="search-button"
          disabled={loading}
        >
          {loading ? '⏳' : '🔍'} {loading ? 'Searching...' : 'Search'}
        </button>
      </form>

      {/* Detect My Location Button */}
      <button
        type="button"
        className="location-button"
        onClick={onDetectLocation}
        disabled={loading || locationLoading}
      >
        📍 {locationLoading ? 'Detecting...' : 'Use My Location'}
      </button>
    </div>
  );
}

export default SearchBar;
